import { Splide } from "@splidejs/splide";

// export function customSplide() {
//     const slider = new Splide('.splide',{
//       // arrows: false, // 矢印ボタンを非表示
//       // pagination: false, // ページネーションを非表示
//       autoplay: true, //自動再生
//       perPage: 1,
//       // breakpoints: {
//       //   767: {
//       //     perPage: 1,
//       //   },
//       // },
//       // gap: "2rem", // ギャップの指定
//       interval: 6000, // 自動再生の間隔
//       type: "fade", // フェード
//       rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す（デフォルトはfalse）
//       speed: 3000, // スライダーの移動時間
//     }).mount();
//   }

export function customSplide() {
  if (document.body.classList.contains("single-works")) {
    const splideElement = document.querySelector(".splide");

    if (splideElement) {
      new Splide(splideElement, {
        pagination: false,
        arrows: true,
        perPage: 1,
        type: "fade",
        rewind: false,
        autoplay: false,
        speed: 800,
      }).mount();
    }
  }
}
